import React from "react";

import BexioDetailDrawer from "../../../components/admin/bexio/workspace/BexioDetailDrawer";
import TenancyDetailContent from "./TenancyDetailContent";

/**
 * The tenancy detail as an overlay (below `lg`).
 *
 * A WRAPPER, NOT A SECOND IMPLEMENTATION. Every field, tab and action lives in
 * `TenancyDetailContent`, which the desktop column renders too. This file
 * contributes the sheet: Escape, the overlay click, the focus trap and the
 * focus return come from the shared drawer (Radix Dialog underneath) rather
 * than being re-implemented here.
 *
 * The shared drawer is named for the workspace it was written in, but it holds
 * nothing Bexio-specific — it is the app's one right-side sheet layout, and a
 * second copy of it is the thing worth avoiding.
 *
 * The sheet title stays the generic "Mietverhältnis" because the content's own
 * header already carries the reference number, the status pill and the object
 * line. Repeating them in the sheet chrome would be the one piece of detail
 * markup existing twice.
 */
export default function TenancyDetailDrawer({
  open,
  onOpenChange,
  tenancy,
  loading,
  error,
  onRetry,
  onCancelled,
}) {
  return (
    <BexioDetailDrawer
      open={open}
      onOpenChange={onOpenChange}
      title="Mietverhältnis"
    >
      <TenancyDetailContent
        tenancy={tenancy}
        loading={loading}
        error={error}
        onRetry={onRetry}
        onCancelled={onCancelled}
      />
    </BexioDetailDrawer>
  );
}
